import React, { useEffect, useState } from "react";
import { supabase } from "../../Services/supabaseClient";
import { useCompany } from "../../context/CompanyContext";
import { useNavigate } from "react-router-dom";
import { RefreshCcw, ArrowRight } from "lucide-react";
import "../../Product/customers.css";

const money = (n) => `₦${Number(n || 0).toLocaleString()}`;

export default function VendorsAging() {
  const { companyId } = useCompany();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [rows, setRows] = useState([]);

  async function load() {
    setErr("");
    if (!companyId) return;
    setBusy(true);
    try {
      const { data, error } = await supabase
        .from("v_vendor_ap_aging")
        .select("*")
        .eq("company_id", companyId)
        .order("total_outstanding", { ascending: false });

      if (error) throw error;
      setRows(data || []);
    } catch (e) {
      setErr(e?.message || "Failed to load aging.");
    } finally {
      setBusy(false);
    }
  }

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);

  return (
    <div className="customers-container">
      <header
        className="cust-head panel"
        style={{ display: "flex", gap: 10, alignItems: "center" }}
      >
        <div style={{ fontWeight: 900, fontSize: 16 }}>Vendors AP Aging</div>
        <button
          className="btn-ghost"
          onClick={load}
          disabled={busy}
          style={{ marginLeft: "auto" }}
        >
          <RefreshCcw size={16} /> Refresh
        </button>
      </header>

      {err && <div className="banner error">{err}</div>}

      <section className="panel table-panel">
        <div className="table-wrap">
          <table className="customer-table">
            <thead>
              <tr>
                <th>Vendor</th>
                <th className="num">Total Outstanding</th>
                <th className="num">0–30</th>
                <th className="num">31–60</th>
                <th className="num">61–90</th>
                <th className="num">90+</th>
                <th className="center">Open</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.vendor_id}>
                  <td>
                    <div className="cell-primary">{r.name}</div>
                    <div className="muted" style={{ fontSize: 12 }}>
                      {r.company_name || ""}
                    </div>
                  </td>
                  <td className="num">{money(r.total_outstanding)}</td>
                  <td className="num">{money(r.bucket_0_30)}</td>
                  <td className="num">{money(r.bucket_31_60)}</td>
                  <td className="num">{money(r.bucket_61_90)}</td>
                  <td className="num">{money(r.bucket_90_plus)}</td>
                  <td className="center">
                    <button
                      className="btn"
                      onClick={() =>
                        navigate(`/vendors/${r.vendor_id}/payments`)
                      }
                    >
                      <ArrowRight size={16} /> Details
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {!rows.length && (
            <div className="empty-state">
              <p>No vendors aging data found.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
